export function getBankCardNumber(last4?: string | null) {
  return last4 ? `xxxx xxxx xxxx ${last4}` : "";
}
